import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0a0a0b]" data-testid="site-footer">
    <div className="relative overflow-hidden border-b border-white/5">
      <div className="marquee py-6">
        <div className="marquee__track font-display text-7xl font-black uppercase tracking-tight text-white/5 md:text-8xl">
          <span>Texas Tough</span>
          <span>·</span>
          <span>Ships Nationwide</span>
          <span>·</span>
          <span>Lone Star Heavy Equipment</span>
          <span>·</span>
          <span>All 50 States</span>
          <span>·</span>
          <span>Iron Sold Here</span>
          <span>·</span>
          <span>Texas Tough</span>
          <span>·</span>
          <span>Ships Nationwide</span>
          <span>·</span>
        </div>
      </div>
    </div>

    <div className="mx-auto grid max-w-[1400px] gap-10 px-6 py-16 lg:grid-cols-4 lg:px-10">
      <div>
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center bg-[#FFB800] font-display text-2xl font-black text-black">
            TI
          </div>
          <div>
            <div className="font-display text-xl font-black uppercase">Texas Iron</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FFB800]">
              Heavy Equipment / TX
            </div>
          </div>
        </div>
        <p className="mt-6 text-sm leading-relaxed text-white/60">
          Family-owned dealer moving serious iron since 1987. Headquartered in Texas, shipping new, used, and refurbished machines to all 50 states.
        </p>
      </div>

      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-[#FFB800]">
          Inventory
        </h4>
        <ul className="mt-4 space-y-3 text-sm text-white/70">
          <li><Link to="/inventory?category=Excavator" className="hover:text-[#FFB800]">Excavators</Link></li>
          <li><Link to="/inventory?category=Bulldozer" className="hover:text-[#FFB800]">Bulldozers</Link></li>
          <li><Link to="/inventory?category=Wheel Loader" className="hover:text-[#FFB800]">Wheel Loaders</Link></li>
          <li><Link to="/inventory?category=Skid Steer" className="hover:text-[#FFB800]">Skid Steers</Link></li>
          <li><Link to="/inventory?category=Crane" className="hover:text-[#FFB800]">Cranes</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-[#FFB800]">
          Company
        </h4>
        <ul className="mt-4 space-y-3 text-sm text-white/70">
          <li><Link to="/about" className="hover:text-[#FFB800]">About Us</Link></li>
          <li><Link to="/financing" className="hover:text-[#FFB800]">Financing</Link></li>
          <li><Link to="/contact" className="hover:text-[#FFB800]">Contact</Link></li>
          <li><Link to="/admin/login" className="hover:text-[#FFB800]">Dealer Login</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-[#FFB800]">
          Yard
        </h4>
        <ul className="mt-4 space-y-4 text-sm text-white/70">
          <li className="flex gap-3">
            <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#FFB800]" />
            <span>4200 FM 1960 East<br />Houston, TX 77032</span>
          </li>
          <li className="flex gap-3">
            <Phone className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#FFB800]" />
            <a href="tel:+18005550123" className="hover:text-[#FFB800]">(800) 555-0123</a>
          </li>
          <li className="flex gap-3">
            <Mail className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#FFB800]" />
            <a href="mailto:support@texasironheavi.com" className="hover:text-[#FFB800]">support@texasironheavi.com</a>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/5">
      <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-white/40 lg:flex-row lg:px-10">
        <span>© {new Date().getFullYear()} Texas Iron Equipment Co. All rights reserved.</span>
        <span className="font-mono uppercase tracking-[0.25em]">Built in Texas · Shipped Nationwide</span>
      </div>
    </div>
  </footer>
);
